<div class="main-content">
  <div class="warranty-registration">
    <!--h1>Global Presence</h1-->
    <div class="banner">
      <picture>
        <source media="(max-width:768px)"
          srcset="{{environment?.blobUrl}}/assets/images/warranty-registration/warranty-registration-mob-banner.webp">
        <img  loading="lazy" [src]="environment?.blobUrl+'/assets/images/warranty-registration/warranty-registration-banner.webp'" alt="Warranty Registration | Luminous">
      </picture>
    </div>
    <div class="container">
      <div class="content">

        <p>All products sold on Luminous Shop Online come with the Manufacturer's warranty & are serviceable at all
          Luminous Authorized Service Centers across India, unless specified otherwise.
        </p>
        <p>If you face any technical issues with the Luminous Products, please contact Luminous Care through:</p>
        <ul>
          <li>Toll Free No: <a href="tel:9999933039">9999933039</a> </li>
          <li>Email ID: <a href="mailto:care@luminousindia.com">care&#64;luminousindia.com</a></li>
          <li>WhatsApp No: <a target="_blank" href="https://wa.link/d4pv0f">+91 7042-833-939</a></li>
        </ul>
        <p>
          After your complaint is registered, our service engineer will visit your place at earliest to provide you the
          desired service. In case your product is within warranty we will provide service free of cost. If your product
          is out of warranty you would be charged accordingly.
        </p>
        <p>Warranty period of Luminous products starts for the date of sale / date of installation whichever is later.
        </p>
        <h1>Paperless warranty:</h1>
        <p>Luminous provides its customers a convenient way to digitally claim warranty on purchased products. Once
          registered digitally, you don't need to show invoice copy or Warranty card whenever service engineer visits to
          your house.</p>
        <p>By registering your product, you also create an account where you can manage your registered products, get
          helpful information, and much more.</p>
      </div>
      <!-- <div class="enquiry-form">
        <div class="enquiry-main pe-0"> -->
      <form class="cst-form-group" [formGroup]="registerProductForm">

        <div class="row">
          <div class="col-md-6 mb-4">
            <!-- Name -->
            <mat-form-field appearance="outline">
              <input matInput type="text" class="cst-form-control" formControlName="name" placeholder="Name" value="" />
              <div class="errorIconContainer" *ngIf="utils.checkValidation('name',registerProductForm)">
                <img class="errorImg"  loading="lazy" [src]="environment?.blobUrl+'/assets/icons/error.svg'" alt="Error | Luminous">
              </div>
              <div class="errorDescription" *ngIf="utils.checkValidation('name',registerProductForm)">
                {{utils.checkValidationMessage(registerProductForm,'name','Name','name')}}
              </div>
            </mat-form-field>
          </div>
          <div class="col-md-6 mb-4">
            <!-- Email -->
            <mat-form-field appearance="outline">
              <input matInput type="text" class="cst-form-control" formControlName="emailAddress" placeholder="Email ID"
                value="" />
              <div class="errorIconContainer" *ngIf="utils.checkValidation('emailAddress',registerProductForm)">
                <img class="errorImg"  loading="lazy" [src]="environment?.blobUrl+'/assets/icons/error.svg'" alt="Error | Luminous">
              </div>
              <div class="errorDescription" *ngIf="utils.checkValidation('emailAddress',registerProductForm)">
                {{utils.checkValidationMessage(registerProductForm,'emailAddress','Email','email')}}
              </div>
            </mat-form-field>
          </div>

          <div class="col-md-6 mb-4">
            <!-- Mobile Number -->

            <mat-form-field appearance="outline">
              <input matInput type="tel" class="cst-form-control" maxlength="10" formControlName="phoneNumber"
                placeholder="Please enter 10-digit Mobile Number" limitNumber
                [limitNumberObj]="{limitPhoneNum: true, limitTo: 10, formGroup: registerProductForm}" />
              <div class="errorIconContainer" *ngIf="utils.checkValidation('phoneNumber',registerProductForm)">
                <img class="errorImg"  loading="lazy" [src]="environment?.blobUrl+'/assets/icons/error.svg'" alt="Error | Luminous">
              </div>
              <div class="errorDescription" *ngIf="utils.checkValidation('phoneNumber',registerProductForm)">
                {{utils.checkValidationMessage(registerProductForm,'phoneNumber','Phone Number','phoneNumber')}}
              </div>
            </mat-form-field>

            <!-- Address -->
          </div>
          <div class="col-md-6 mb-4">
            <mat-form-field appearance="outline">
              <input matInput type="text" class="cst-form-control" formControlName="streetAddress" placeholder="Address"
                value="" />
              <div class="errorIconContainer" *ngIf="utils.checkValidation('streetAddress',registerProductForm)">
                <img class="errorImg"  loading="lazy" [src]="environment?.blobUrl+'/assets/icons/error.svg'" alt="Error | Luminous">
              </div>
              <div class="errorDescription" *ngIf="utils.checkValidation('streetAddress',registerProductForm)">
                {{utils.checkValidationMessage(registerProductForm,'streetAddress','Address','streetAddress')}}
              </div>
            </mat-form-field>
          </div>

          <div class="col-md-6 mb-4">
            <!-- Pincode -->

            <mat-form-field appearance="outline">
              <input matInput type="tel" class="cst-form-control" maxlength="6" (input)="getPincodeDetails($event)"
                formControlName="pincode" placeholder="Enter Pincode" limitNumber
                [limitNumberObj]={limitPhoneNum:false,limitTo:6,formGroup:registerProductForm} />
              <div class="errorIconContainer" *ngIf="utils.checkValidation('pincode',registerProductForm)">
                <img class="errorImg"  loading="lazy" [src]="environment?.blobUrl+'/assets/icons/error.svg'" alt="Error | Luminous">
              </div>
              <div class="errorDescription" *ngIf="utils.checkValidation('pincode',registerProductForm)">
                {{utils.checkValidationMessage(registerProductForm,'pincode','Pincode','pincode')}}
              </div>
            </mat-form-field>
          </div>

          <div class="col-md-6 mb-4">
            <!-- City -->

            <mat-form-field appearance="outline">
              <input matInput type="text" class="cst-form-control" formControlName="city" placeholder="Enter City" />
              <div class="errorIconContainer" *ngIf="utils.checkValidation('city',registerProductForm)">
                <img class="errorImg"  loading="lazy" [src]="environment?.blobUrl+'/assets/icons/error.svg'" alt="Error | Luminous">
              </div>
              <div class="errorDescription" *ngIf="utils.checkValidation('city',registerProductForm)">
                {{utils.checkValidationMessage(registerProductForm,'city','City','city')}}
              </div>
            </mat-form-field>


          </div>
          <div class="col-md-6 mb-4">

            <!-- State -->

            <mat-form-field appearance="outline">
              <input matInput type="text" class="cst-form-control" formControlName="state"
                placeholder="State(Auto Fetch)" readonly />
            </mat-form-field>

          </div>
          <div class="col-md-6 mb-4">
            <!-- Category -->
            <mat-form-field class="position-relative custom-error">
              <mat-label>Category</mat-label>
              <mat-select formControlName="category">
                <mat-option *ngFor="let selectData of categoryList" [value]="selectData.value">
                  {{selectData.viewValue}}
                </mat-option>
              </mat-select>
              <div class="errorIconContainer" *ngIf="utils.checkValidation('category',registerProductForm)">
                <img class="errorImg"  loading="lazy" [src]="environment?.blobUrl+'/assets/icons/error.svg'" alt="Error | Luminous">
              </div>
              <div class="errorDescription" *ngIf="utils.checkValidation('category',registerProductForm)">
                {{utils.checkValidationMessage(registerProductForm,'category','Product Category','category')}}
              </div>
            </mat-form-field>
          </div>
          <div class="col-md-6 mb-4">
            <!-- Alphanumeric Code -->

            <mat-form-field appearance="outline">
              <input matInput type="text" class="cst-form-control" formControlName="alphanumericCode" maxlength="14"
                placeholder="Enter 14-digit serial number" value="" />
              <div class="errorIconContainer" *ngIf="utils.checkValidation('alphanumericCode',registerProductForm)">
                <img class="errorImg"  loading="lazy" [src]="environment?.blobUrl+'/assets/icons/error.svg'" alt="Error | Luminous">
              </div>
              <div class="errorDescription" *ngIf="utils.checkValidation('alphanumericCode',registerProductForm)">
                {{utils.checkValidationMessage(registerProductForm,'alphanumericCode','Alpha Numeric
                Code','alphanumericCode')}}
              </div>
            </mat-form-field>
          </div>
          <div class="col-md-12 mb-5">

            <!-- <label class="d-block mb-3">Purchase Proof<span class="text-danger">*</span></label>
            <input id="featureImg" accept="image/x-png,image/jpg,image/jpeg" formControlName="purchaseProofFile" (change)="fileUpload($event)" type="file"
              alt="File Upload | Luminous"> -->
            <label class="d-block mb-3">Purchase Proof<span class="text-danger">*</span></label>
            <div class="d-flex align-items-center">
              <input id="featureImg" accept="image/x-png,image/jpg,image/jpeg" hidden (change)="fileUpload($event)"
                type="file" alt="File Upload | Luminous">
              <label class="primaryBtn " for="featureImg">
                Choose Image
              </label>
              <p class="ms-4">{{registerProductForm?.value?.['purchaseProofFileName']}}</p>
            </div>
            <span class="description">Supported file types for purchase proof are JPG,
              JPEG, PNG and maximum allowed size is 1MB.</span>
          </div>
        </div>
        <button class="primaryBtn" type="button" [disabled]="registerProductForm.invalid"
          (click)="formSubmitted()">Submit</button>
      </form>
    </div>

  </div>
</div>
